export default __webpack_public_path__ + "static/media/megane-gallery-4.86ce8dfb.jpg";